<template>
  <div id="auth" :class="themeStyle">
    <Authentication v-if="isAuth" />
  </div>
</template>

<script>
import attempt from 'lodash/attempt';
import Authentication from '@/components/_common/Authentication';

export default {
  name: 'Auth',
  components: {
    Authentication,
  },
  methods: {
    parse(str) {
      return attempt(JSON.parse.bind(null, str));
    },
  },
  computed: {
    themeStyle() {
      return this.$frameparams.style;
    },
    isAuth() {
      return this.$frameauth;
    },
  },
};
</script>

<style lang="scss">
  #auth {
    .octobus__modal-card-foot {
      height: auto;
    }
  }
</style>




// WEBPACK FOOTER //
// src/Auth.vue